var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-16 mb-0 star-rate"},_vm._l((_vm.stars),function(index){return _c('i',{key:index,staticClass:"fa-star pr-1 fa-4x",class:_vm.rated > index - 1
        ? 'fas rated-color'
        : _vm.rate > index - 1
        ? 'fas hover-color'
        : 'far',style:(`font-size: ${_vm.size};`),on:{"mouseover":function($event){return _vm.changeRate(index)},"mouseleave":function($event){return _vm.changeRate(0)},"click":function($event){return _vm.changeRated(index)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }